<script setup lang="ts">
import { useCommonStore } from "~/stores/common";
import { useShopStore } from "~/stores/shop";

const head = useLocaleHead({
	addDirAttribute: true,
	identifierAttribute: "id",
	addSeoAttributes: true
});
const { cookieConsent } = useCommonStore();
const shopStore = useShopStore();

await useAsyncData("/shop/components", () => shopStore.getAllComponents());
</script>

<template>
	<Html :lang="head.htmlAttrs.lang" :dir="head.htmlAttrs.dir">
		<Head>
			<template v-for="meta in head.meta" :key="meta.id">
				<Meta :id="meta.id" :property="meta.property" :content="meta.content" />
			</template>
			<template v-for="link in head.link" :key="link.id">
				<Link :id="link.id" :rel="link.rel" :href="link.href" :hreflang="link.hreflang" />
			</template>
		</Head>
		<Body>
			<LayoutHeader />
			<main>
				<NuxtErrorBoundary>
					<template #default>
						<slot></slot>
						<ClientOnly>
							<TransitionFade>
								<CommonButtonScrollTop />
							</TransitionFade>
						</ClientOnly>
						<TransitionFade>
							<LayoutCookieAgreement
								v-if="!cookieConsent.isSeen"
								class="fixed bottom-3 right-6 z-50 md:left-6 sm:left-6 xs:left-4 xs:right-4"
							/>
						</TransitionFade>
					</template>
					<template #error="{ error, clearError }">
						<CommonErrorMessage
							class="h-[692px]"
							:error="error"
							caught-in-error-boundary
							@clear-error="clearError"
						/>
					</template>
				</NuxtErrorBoundary>
			</main>
			<LayoutFooter />
			<CommonModals />
		</Body>
	</Html>
</template>
